import Typography, { ETypo, ETypoColor } from "@Front/Components/DesignSystem/Typography";
import { usePublicSiteBrandingAssets } from "@Front/Services/PublicSiteConfig/usePublicSiteBrandingAssets";
import { usePublicUiOptions } from "@Front/Services/PublicSiteConfig/usePublicUiOptions";
import classes from "../classes.module.scss";

type StepEmailHeaderProps = {
	welcomeTitle: string;
	welcomeSubtitle?: string;
};

export default function StepEmailHeader({ welcomeTitle, welcomeSubtitle }: StepEmailHeaderProps): React.JSX.Element {
	const { logoSmallUrl } = usePublicSiteBrandingAssets();
	const { public_ui } = usePublicUiOptions();
	const showCenterBrandMark = public_ui.login_show_center_brand_mark;
	return (
		<div className={classes["header"]}>
			{showCenterBrandMark && <img src={logoSmallUrl} alt="Logo" height={56} width={56} />}
			<Typography typo={ETypo.TITLE_H1} color={ETypoColor.TEXT_ACCENT}>
				{welcomeTitle}
			</Typography>
			{welcomeSubtitle && <Typography typo={ETypo.TITLE_H5}>{welcomeSubtitle}</Typography>}
		</div>
	);
}
